<!--
 * @Author: your name
 * @Date: 2020-06-28 11:14:04
 * @最后修改时间: 2022-04-07 14:54:10
 * @最后编辑: Betway
 * @Description: In User Settings Edit
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Punch\PunchRecord\PunchRecord.vue
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_admin_punchRecord_list_title')"
    pad="0"
    @activated="activated"
    filterable
    @filter="
      (val) => {
        filterPageData = val;
      }
    "
  >
    <!-- 筛选 -->
    <template v-slot:top-selection="{ filter }">
      <Selections2
        :objects="filterObjects"
        small-chip
        @filter="
          filter();
          toFilter(1, filter);
        "
        @update="
          (prop, value, selected) => {
            $fliterValue(filterObjects, prop, value, selected);
          }
        "
        @reset="
          (apply) => {
            $fliterValue(filterObjects, null, null);
            if (apply) {
              filter();
              toFilter(1, filter);
            }
          }
        "
      />
    </template>
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :showSelect="showSelect"
        :height="$vuetify.breakpoint.height - 275 - 48"
        :totalCount="totalCount"
        :filter-page-data="filterPageData"
        overLoading
        @change="
          (page, perpage, callback, data) => {
            getList(data, page, perpage, callback);
          }
        "
      >
        <template v-slot:item.name="{ item }">
          <div style="max-width: 300px">
            <v-list-item class="pa-0" dense two-line>
              <v-list-item-avatar size="36" class="mr-1 my-0">
                <StaffAvatar
                  size="36"
                  :src="item.staff_avatar"
                  :staff_name="item.preferred_name"
                />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text--primary">
                  {{ $getCommonLangValue(item.preferred_name) }}
                  <span class="text--secondary text-caption-xs">
                    {{ item.staff_code }}</span
                  >
                </v-list-item-title>
                <v-list-item-subtitle class="text--secondary">{{
                  $getCommonLangValue(item.job_post_name)
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
        </template>
        <template v-slot:item.date="{ item }">
          {{ $getDateTime(item.punch_utc_datetime, "YYYY/MM/DD") }}
        </template>
        <template v-slot:item.site_name="{ item }">
          {{ $getCommonLangValue(item.site_name) }}
        </template>
        <template v-slot:item.time="{ item }">
          {{ $getDateTime(item.punch_utc_datetime, "HH:mm") }}
        </template>
        <template v-slot:item.criteria="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <svg-icon
                  size="24"
                  fill="transparent"
                  :iconClass="
                    Number(item.punch_criteria_matched) ? 'Done' : 'Alert'
                  "
                />
              </div>
            </template>
            {{
              Number(item.punch_criteria_matched)
                ? $t("message_essweb_punchRecord_list_tip_criteriaMatchedLabel")
                : $t(
                    "message_essweb_punchRecord_list_tip_criteriaNotMatchedLabel"
                  )
            }}
          </v-tooltip>
        </template>
        <template v-slot:item.source="{ item }">{{
          item.source === null
            ? ""
            : Number(item.source) == 0
            ? $t("label_essweb_punchRecord_list_appLabel")
            : Number(item.source) == 1
            ? $t("label_essweb_punchRecord_list_dkjLabel")
            : ""
        }}</template>
        <template v-slot:item.tag="{ item }">
          <v-chip
            class="mr-1 white--text"
            small
            :color="$getTagColors($card_line_colors, 'is_work_from_home_1')"
            v-if="Number(item.is_work_from_home)"
            >{{
              $t("label_essweb_punchRecord_list_tag_workFromHomeLabbel")
            }}</v-chip
          >
          <v-chip
            class="mr-1 white--text"
            :color="$getTagColors($card_line_colors, 'is_out_of_office_1')"
            small
            v-if="Number(item.is_out_of_office)"
            >{{
              $t("label_essweb_punchRecord_list_tag_fieldServiceLabel")
            }}</v-chip
          >
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn
            icon
            @click="toView(item.uuid)"
            v-if="hasBtn('view-admin-clock-in-record')"
          >
            <svg-icon size="24" fill="currentColor" iconClass="viewDetail" />
          </v-btn>
        </template>
      </Tabler>
    </template>
    <!-- tools -->
    <template v-slot:tools-main>
      <viewPuchRecord
        :show="showDetail"
        @close="
          showDetail = false;
          curUuid = null;
        "
        :curUuid="curUuid"
      />
    </template>
    <!-- tools -->
  </ContentLayout>
</template>
<script>
import viewPuchRecord from "@/Page/EssAdmin/Punch/PunchRecord/components/viewPunchRecord";
export default {
  name: "PunchRecord",
  components: { viewPuchRecord },
  computed: {},
  data() {
    return {
      search: "",
      curUuid: null,
      totalCount: 0,
      showDetail: false,
      showSelect: false,
      headers: [
        {
          text: "label_essweb_punchRecord_list_staffLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_punchRecord_list_dateLabel",
          value: "date",
          align: "start",
          sortable: true,
          sort: (prop, desc, calback) => {
            return this.$sortList(
              this.desserts,
              "punch_utc_datetime",
              desc ? true : false,
              "datetime"
            ).then((res) => {
              calback(desc);
              this.desserts = res;
            });
          },
        },
        {
          text: "label_essweb_punchRecord_list_timeLabel",
          value: "time",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_punchRecord_list_punchSourceLabel",
          value: "source",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_punchRecord_list_siteNameLabel",
          value: "site_name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_punchRecord_list_tagLabel",
          value: "tag",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_punchRecord_list_criteriaLabel",
          value: "criteria",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
      filterPageData: null,
      filterObjects: [
        {
          type: "select",
          sequence: 0,
          position: "right",
          showKey: "preferred_name",
          subKey: "job_post_name",
          avatar: true,
          twoLine: true,
          name: "staff",
          multiple: true,
          label: "label_essweb_punchRecord_list_staffLabel",
          value: [],

          selected: [],
          data: {
            api: "all_staff",
            url_type: "all_staff",
            args: null,
            table: "mrbase_sys_staffs",
            type: "",
            modelKey: "staff_code",
            valueKey: "staff_id",
            global: false,
          },
        },
        {
          type: "daterange",
          sequence: 0,
          name: "date",
          position: "right",
          label: "label_essweb_punchRecord_list_dateLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "select",
          sequence: 0,
          position: "right",
          showKey: "dict_label",
          name: "staff_status",
          disabled: false,
          multiple: true,
          label: "label_essweb_UM_filters_jobStatusLabel",
          value: [],
          selected: [],
          data: {
            api: "/dictionary/list-dictionary-byname/",
            url_type: "primary",
            args: { dict_name: "staffStatus" },
            table: "mrbase_sys_dict",
            type: "lang",
            modelKey: "dict_label",
            valueKey: "dict_value",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 1,
          position: "right",
          name: "site",
          multiple: true,
          label: "label_essweb_punchRecord_list_siteNameLabel",
          value: "",

          selected: [],
          data: {
            api: "ess_site_select",
            url_type: "prompt",
            args: null,
            table: "x",
            type: "",
            modelKey: "view_fields",
            valueKey: "value_field",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 2,
          position: "right",
          name: "status",
          multiple: false,
          label: "label_essweb_punchRecord_list_criteriaLabel",
          value: "",
          selected: [],
          data: {
            api: "ess_boolean_select",
            url_type: "prompt",
            args: null,
            table: "x",
            type: "",
            modelKey: "view_fields",
            valueKey: "value_field",
            global: false,
          },
        },
      ],
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(null, 1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    activated(refresh) {
      const that = this;
      if (refresh == 0) {
        this.$fliterValue(this.filterObjects, null, null);
        // if (this.page !== null) {
        this.desserts = [];
        this.getList(null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
        // }
      }
      if (refresh == 1) {
        if (this.page !== null) {
          this.toFilter(null, () => {});
        } else {
          this.toFilter(1, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
        }
      }
    },
    toFilter(tab, callback) {
      const that = this;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "date") {
          data["punch_utc_start_datetime"] = that.$getTimeValue(
            item.value ? item.value.split(" - ")[0] : ""
          );
          data["punch_utc_end_datetime"] = that.$getTimeValue(
            item.value ? item.value.split(" - ")[1] : ""
          );
        }

        if (item["name"] == "staff") {
          data["staff_uuid"] = item.value.join(",");
        }
        if (item["name"] == "site") {
          data["site_uuid"] = item.value.join(",");
        }
        if (item["name"] == "status") {
          data["status"] = item.value;
        }
        if (item["name"] == "staff_status")
          data["staff_status"] = item.value ? item.value.join(",") : "";
      });
      if (tab) {
        this.getList(data, 1, this.$tableSetting.perPageSize, callback);
      } else {
        this.getList(
          data,
          this.page ? this.page : 1,
          this.pagesize ? this.pagesize : this.$tableSetting.perPageSize,
          callback
        );
      }
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
    toView: function (uuid) {
      this.curUuid = uuid;
      this.showDetail = true;
    },
    getList: function (data, page, perpage, callback) {
      const that = this;
      if (data) {
        data["cpage"] = page;
        data["pagesize"] = perpage;
      }
      this.$Request({
        method: "POST",
        table: "ess_punch_records_master",
        url: "/punch-record/get-punch-record-list/",
        data: data ? data : { cpage: page, pagesize: perpage },
        global:
          page == 1 && perpage == this.$tableSetting.perPageSize ? true : false,
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback(page, perpage, data) : null;
      });
    },
  },
};
</script>
